module.exports = __webpack_public_path__ + "img/wzjs4.9715ee54.jpg";